import useCMS from '@telescope/react-hooks/useCMS';
import { CmsData, VideoData } from 'models';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { MIN_POLLING_RATE } from 'util/constants';
import { getQueryParamByName } from 'util/helpers';

export default function useSessionVideos(route: string) {
  const mainCms = useSelector((state: RootState) => state.widget.cms);
  const videoPollingRate = useSelector((state: RootState) => state.widget.cms.text.settings.video_wid_polling_rate_ms);

  const wid = getQueryParamByName('v_wid') || mainCms.settings.videos_wid;
  const sid = getQueryParamByName('v_sid');

  const [videosCms] = useCMS<CmsData>(wid, { sid, pollingFrequency: videoPollingRate || MIN_POLLING_RATE });
  const [videos, setVideos] = useState<Array<VideoData>>([]);

  useEffect(() => {
    if (!videosCms) return;
    const sessionVideos = videosCms.data.filter((video) => video.page.includes(route));
    setVideos(sessionVideos);
  }, [videosCms, route]);

  return videos;
}
